<template>
    <div class="row">
        <input-date-time class="col-12 col-md-4" label="Data de emissão ou despesa" v-model="form.data" ref="data_desembolso" required/>
        <input-money class="col-12 col-md-4" label="Valor" v-model="form.valor" ref="valor_custo" required/>
        <input-select class="col-12 col-md-4" label="Rubrica" v-model="form.rubrica" :options="options.rubricas" ref="rubrica" required/>
        <div class="col-12 mb-2">
            <upload v-if="!form.nomeArquivoAWS"
                :id="`upload_custo_${i}`"
                tituloArquivo="Arrastar Arquivo" 
                selecioneArquivo="Selecionar Arquivo" 
                type=".*"

                :arquivo-download="form.conteudoBase64"
                :arquivo-download-nome="form.nomeArquivoAWSUP"
                
                @upload="(file, nomeArquivo)=> {                   
                    form.nomeArquivoAWSUP = nomeArquivo;
                    form.conteudoBase64 = file;
                    this.$forceUpdate();
                }" 
            />

            <template v-if="form.nomeArquivoAWS">
                <div>
                    Arquivo
                    <div class="lista-arquivos d-flex">
                        <b-button variant="danger" @click="() =>{this.form.nomeArquivoAWS = null;}" class="m-2" size="sm">
                            <b-icon icon="trash" class="mr-2" />
                            Remover arquivo
                        </b-button>
                        <b-button variant="info" @click="() => {this.$emit('downloadArquivo', this.form.id);}" class="m-2" size="sm">
                            <i class="fas fa-cloud-download"></i>
                        </b-button>
                        <div  style="border-left: 1px solid #e5e5e5;" class="lista-arquivos__left d-flex pl-2 align-items-center">
                            {{form.nomeArquivoAWS}}
                        </div>
                    </div>
                </div>
            </template>
        </div>  
    </div>
</template>
<script>
import helpers from "@/common/utils/helpers";
import {FormMixin} from "@/common/mixins/FormMixin";
import InputDateTime from "@/components/inputs/InputDateTime";
import InputSelect from "@/components/inputs/InputSelect";
import InputMoney from "@/components/inputs/InputMoney";
import Upload from "@/components/upload/Upload";
export default {
    mixins: [FormMixin],
    components : {
        InputDateTime,
        InputSelect,
        InputMoney,
        Upload,
    },
    props : {
        form : {
            required : true,
        }
    },
    data : () => ({
        options : {      
            rubricas : helpers.Rubricas,
        }
    }),
}
</script>
<style>
    .lista-arquivos{
        border: 1px solid #e5e5e5;
        background: #f9f9f9;
    }
    .lista-arquivos__no_top{
        border-top: none;
    }
    .lista-arquivos__left{
        border-left: 1px solid #e5e5e5;
    }
</style>